import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatTableDataSource, MatPaginator, MatSort } from '@angular/material';

import { UIService } from '../../services/ui.service';
import { APIService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'cs-parcelas',
    templateUrl: './parcelas.component.html',
    styleUrls: ['./parcelas.component.scss']
})
export class ParcelasComponent implements OnInit {

    public _columns: string[] = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    public model: any = {
        Status: 0,
        FiltroCliente: {
        },
        FiltroEstabelecimento: {
        }
    };

    public StatusParcela: any[] = [
        { ID: 1, Descricao: 'Agendada', Cor: '' },
        { ID: 2, Descricao: 'Efetivada', Cor: '#ccffcc' },
        { ID: 3, Descricao: 'Negada', Cor: '#ff9999' },
        { ID: 4, Descricao: 'Renegociada', Cor: '#d9d9d9' },
        { ID: 5, Descricao: 'Substituida', Cor: '#d9d9d9' },
        { ID: 6, Descricao: 'Pagamento Cancelado', Cor: '#d9d9d9' },
        { ID: 7, Descricao: 'Aguardando Reprocessamento', Cor: '#ffff99' },
        { ID: 8, Descricao: 'Agendamento Cancelado', Cor: '#ffff99' },
        { ID: 9, Descricao: 'Cancelado Teste', Cor: '#ffb3d9' },
        { ID: 10, Descricao: 'Agendado Manual', Cor:  '#ccff99'},
        { ID: 11, Descricao: 'PagoEmLoja', Cor: '#0FCB33' },
        { ID: 12, Descricao: 'Aguardando Cancelamento Pagamento', Cor: '#eaea90' },
        { ID: 13, Descricao: 'Pago em Boleto', Cor: '#99ff33' }
    ];

    public TiposPagamento: any[] = [
        { ID: 1, Descricao: 'Credito', Cor: '' },
        { ID: 2, Descricao: 'Credito Parcelado', Cor: '' },
        { ID: 3, Descricao: 'Credito Recorrente', Cor: '' },
        { ID: 4, Descricao: 'Debito', Cor: '' },
        { ID: 5, Descricao: 'Boleto', Cor: '' },
        { ID: 6, Descricao: 'Em Loja', Cor: '' },
        { ID: 7, Descricao: 'Outros', Cor: '' }
    ];

    public itens: any[] = [];
    public listRedes: any[] = [];
    public listGrupos: any[] = [];
    public listStatus: any[] = [];

    public total: number;
    public dataSource = new MatTableDataSource<any>(this.itens);

    constructor(public dialog: MatDialog, private ui: UIService, private api: APIService, private router: Router, private storage: StorageService) {
    }

    ngOnInit() {

        setTimeout(() => {

            this._columns = ['Acoes',
            'Venda', 'DataVencimento', 'Valor', 'Status', 'DiasAtraso',
            'DataPagamento', 'Autorizadora', 'Rede', 'Cliente', 'Estabelecimento'];

            this.paginator.pageSize = 10;

            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.loadSession();

            this.listStatus = [{
                ID: 0,
                Descricao: 'Todos',
                Cor: ''
            }].concat(this.StatusParcela);

            this.ui.block('Pesquisando redes...');
            this.api.listarRedes({}).subscribe(

                (response: any) => {

                    this.ui.unblock();

                    if (response.error) {

                        this.ui.error(response.error);
                    }
                    else {

                        if (response.data.Redes.length > 1) {
                            this.listRedes = [{
                                ID: '',
                                Nome: 'Todas'
                            }].concat(response.data.Redes);
                            this.model.FiltroEstabelecimento.RedeID = '';
                        } else {
                            this.listRedes = response.data.Redes;
                            this.model.FiltroEstabelecimento.RedeID = this.listRedes[0].ID;
                            this.listGrupos = this.listRedes[0].Grupos;
                        }

                    }

                }
            );


        });
    }

    limparFiltro() {

        this.model = {
            Status: 0,
            FiltroCliente: {
            },
            FiltroEstabelecimento: {
            }
        };
    }

    filtrar(page?: number, reset = false, gerarExcel = false) {

        this.ui.block('Pesquisando parcelas...');

        let skip: number = (page || this.paginator.pageIndex) * this.paginator.pageSize;
        if (reset) {
            skip = 0;
            this.paginator.pageIndex = 0;
        }
        const parameter: any = JSON.parse(JSON.stringify(this.model));

        parameter.Take = this.paginator.pageSize;
        parameter.Skip = skip;
        parameter.GerarExcel = gerarExcel;

        //if (this.sort && this.sort.direction) {
        //    parameter.Sort = this.sort.active + '|' + this.sort.direction;
        //}
        //else {
        //    parameter.Sort = 'Nome|asc';
        //}

        if (parameter.DataVendaDe) parameter.DataVendaDe = this.dateJS2DOTNET(parameter.DataVendaDe);
        if (parameter.DataVendaAte) parameter.DataVendaAte = this.dateJS2DOTNET(parameter.DataVendaAte);
        if (parameter.DataVencimentoDe) parameter.DataVencimentoDe = this.dateJS2DOTNET(parameter.DataVencimentoDe);
        if (parameter.DataVencimentoAte) parameter.DataVencimentoAte = this.dateJS2DOTNET(parameter.DataVencimentoAte);
        if (parameter.DataPagamentoDe) parameter.DataPagamentoDe = this.dateJS2DOTNET(parameter.DataPagamentoDe);
        if (parameter.DataPagamentoAte) parameter.DataPagamentoAte = this.dateJS2DOTNET(parameter.DataPagamentoAte);
        if (parameter.FiltroEstabelecimento && parameter.FiltroEstabelecimento.GrupoID=="") {
            parameter.FiltroEstabelecimento.GrupoID = '00000000-0000-0000-0000-000000000000';
        }
        if (parameter.FiltroEstabelecimento && parameter.FiltroEstabelecimento.RedeID=="") {
            parameter.FiltroEstabelecimento.RedeID = '00000000-0000-0000-0000-000000000000';
        }

        this.api.obterParcelas(parameter).subscribe(

            (response: any) => {
                this.ui.unblock();

                if (response.error) {

                    this.ui.error(response.error);
                }
                else {

                    //Gerar a planilha
                    if(response.data.Base64){
                        const linkSource = 'data:application/xlsx;base64,' + response.data.Base64;
                        const downloadLink = document.createElement("a");
                        const fileName = "parcelas.xlsx";

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }

                    this.total = response.data.Total;
                    this.itens = response.data.Parcelas;

                    this.dataSource = new MatTableDataSource<any>(response.data.Parcelas);

                    if (page) {

                        this.paginator.pageIndex = page;
                    }
                }

                this.storage.set('session', undefined);
            }
        );
    }

    pageChanged(page: any) {

        this.filtrar();
    }

    sortChanged(sort: any) {

        this.filtrar();
    }

    showRecord(element: any) {

        this.saveSession();
        this.router.navigate(['/consultavendas', element.VendaID]);
    }

    saveSession() {

        this.storage.set('session', {
            model: this.model,
            page: {
                size: this.paginator.pageSize,
                current: this.paginator.pageIndex
            },
            sort: {
                field: this.sort.active,
                direction: this.sort.direction
            }
        });
    }

    loadSession() {

        const session = this.storage.get('session');

        if (session) {

            this.model = session.model;

            if (!this.model.FiltroCliente)
                this.model.FiltroCliente = {};
            if (!this.model.FiltroEstabelecimento)
                this.model.FiltroEstabelecimento = {};

            this.paginator.pageSize = session.page.size;
            this.sort.active = (session.sort) ? session.sort.field : 'Venda';
            this.sort.direction = (session.sort) ? session.sort.direction : 'desc';

            this.filtrar(session.page.current);
        }
        else {

            if (!this.model.DataVencimentoAte) {
                this.model.DataVencimentoAte = new Date(new Date().setHours(0,0,0,0)).toISOString();
            }
            this.filtrar();
        }
    }

    rowSelected(row: any) {
    }

    redeSelected(e) {
        var grupos = [];
        if (!e.value) {
            this.model.FiltroEstabelecimento.GrupoID = '';
            this.listGrupos = grupos;
        } else {
            const rede = this.listRedes.filter((r) => {
                return r.ID == e.value;
            });
            if (!rede.length) {
                this.model.FiltroEstabelecimento.GrupoID = '';
                this.listGrupos = grupos;
            } else {
                grupos = rede[0].Grupos;
                if (grupos.length == 0) {
                    this.listGrupos = grupos;
                } else if (grupos.length == 1) {
                    this.model.FiltroEstabelecimento.GrupoID = grupos[0].ID;
                    this.listGrupos = grupos;
                } else {
                    this.model.FiltroEstabelecimento.GrupoID = '';
                    this.listGrupos = [{
                        "ID": "",
                        "Nome": "Todos"
                    }].concat(grupos);

                }
            }

        }

    }

    telefone(telefone: string) {

        if (telefone && telefone.length === 11) {

            return '(' + telefone.substr(0, 2) + ') ' + telefone.substr(2, 5) + '-' + telefone.substr(7, 4);
        }
        else {

            return telefone;
        }
    }

    dateDOTNET2JS(d) {
        const t = (d || '').match(/\/Date\((\d+)(\+|\-)(\d{2})(\d{2})\)\//) || [];
        if (t.length==5) {
          return new Date(parseInt(t[1]) + parseInt(t[2]+t[3])*3600000 + parseInt(t[2]+t[4])*60000);
        }
        const u = (d || '').match(/\/Date\((\d+)\)\//) || [];
        if (u.length==3) {
          return new Date(parseInt(u[1])/1000);
        }
        return null;
    }

    dateJS2DOTNET(d) {
        if (d) {
            const t: any = new Date(d);
            return '/Date(' + (t * 1) + '+0000)/';
        }
        return null;
    }

}
